import { render, staticRenderFns } from "./TaskStoriesModal.vue?vue&type=template&id=283e5e6e&"
import script from "./TaskStoriesModal.vue?vue&type=script&lang=js&"
export * from "./TaskStoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskStoriesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports